module.exports = __webpack_public_path__ + "static/img/page1.3474cf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recordPublicity/page1.jpg
// module id = uxqP
// module chunks = 28 80